
import { allTranslations } from './languages';

type LanguageTranslations = Record<string, string>;
type FallbackTranslationsType = Record<string, LanguageTranslations>;

// Re-export translations from the individual language files
export const fallbackTranslations: FallbackTranslationsType = allTranslations;
